
import { defineComponent, ref } from 'vue';
import { setLocale, useI18n, isLocaleSupported } from '@/i18n';
import {
  LABEL_DUTCH_SELF,
  LABEL_ENGLISH_SELF,
  LABEL_FRENCH_SELF,
  LABEL_GERMAN_SELF,
  LABEL_ITALIAN_SELF,
  LABEL_PORTUGUESES_SELF,
  LABEL_RUSSIAN_SELF,
  LABEL_SPANISH_SELF,
} from '@/libs/i18nLabels';

export default defineComponent({
  setup() {
    const i18n = useI18n();

    const selected = ref(i18n.locale.value || 'en');

    // Replace parameter in url
    // const qp = new URLSearchParams(window.location.search.substring(1));

    function updateQueryString() {
      // qp.delete('lang');
      // qp.set('lg', selected.value);
      // window.history.replaceState(null, '', `?${qp.toString()}`);
    }

    function updateLocale() {
      setLocale(i18n, selected.value);
      updateQueryString();
    }

    return { updateLocale, selected };
  },

  props: {},

  emits: ['focus', 'blur'],

  computed: {
    options() {
      return [
        { id: 'en', text: this.$t(LABEL_ENGLISH_SELF) },
        { id: 'en_GB', text: `${this.$t(LABEL_ENGLISH_SELF)} (UK)` },
        { id: 'fr', text: this.$t(LABEL_FRENCH_SELF) },
        { id: 'nl', text: this.$t(LABEL_DUTCH_SELF) },
        { id: 'pt', text: this.$t(LABEL_PORTUGUESES_SELF) },
        { id: 'es', text: this.$t(LABEL_SPANISH_SELF) },
        { id: 'it', text: this.$t(LABEL_ITALIAN_SELF) },
        { id: 'de', text: this.$t(LABEL_GERMAN_SELF) },
        { id: 'ru', text: this.$t(LABEL_RUSSIAN_SELF) },
      ].filter((t) => isLocaleSupported(t.id));
    },

    selectedValue() {
      const selectedValue = this.selected;

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const values = this.options as any;

      let v;
      for (let i = 0; i < values.length; i += 1) {
        v = values[i];
        if (v.id === selectedValue) {
          return v.text;
        }
      }
      return '';
    },
  },
});
